import CountDown from "../countdown/countdown";
import {Typography} from "@material-ui/core";
import React from "react";

const clockImagePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATtJREFUeNqklLFKA0EQhocIiUUCgRRphKSwzAMEtdC0Qh5AL+IDJEUgqaOPkFxn4ZOIGN8hpaAgZwRNKenWf/BfGJe9qPjDx7Azc//NLbsnzjkJKIMhmIN39yWNd8yXw2dCg1Pw4jZL60meycQ0PoAR2Ae7jCPmvSahyYkppqDI/B64ZxTmU9ObeBP9xqUxsNOlP+TfQLUgIuegDp7AWL5rK4heY/bXQKImXRauwFp+pzX7VV01aXFxK3+T728VOJIqizR+MB6DZlBbMtZ0kzJuUjty8HbAI+saG6bWZj7TSRZ07EQmeQaH3MQGuDS1I8aFOvbNm7Yj0yhNcA0OuC6ZCfuaqJhzMssxCZnZc2LvjNfUnNiQIutevf/enYu8W9wzn5anV3C26Vfg79IA3IAVH1xxPYj9Tz4FGAClh8c878J3wQAAAABJRU5ErkJggg==';

export const LiveInCountdown = ({toDate, toDateFormat, onTick, onCountdownEnd}) => {
    return (<Typography variant={'h6'} style={{fontSize: '2em'}}>
        Live In:
        <CountDown
            toDateFormat={toDateFormat} toDate={toDate}
            style={{
                background: "url('" + clockImagePng + "') no-repeat scroll center left transparent",
                paddingLeft: '30px'
            }}
            onTick={onTick}
            onCountdownEnd={onCountdownEnd}
        />
    </Typography>);
}
